import { useState } from 'react'
import SignageFilterSelect from '../../components/PageSignageLite/SignageFilterSelect'
import { ErrorMessage, Field } from 'formik'
import Translation from '../../components/Translation/cont/Translation'
import FieldWrapper from '../../components/forms/FieldWrapper'

const SignageFilterSelectContainer = ({name, filterItems, transId}) => {
    return <FieldWrapper label={<Translation id={'signage_filter_' + transId}/>} id={name} classes="field-text">
        <Field
            name={name}
            filterItems={filterItems}
            id={name}
            component={SignageFilterSelect}
        />
        <ErrorMessage name={name} component="div" /> 
    </FieldWrapper>
}

export default SignageFilterSelectContainer